(function(){
    'use strict';

    angular.module('dataHandlingActionAddList', ['ngAnimate', 'journey.canvas.srv', 'ngModalDragabble'])
        .controller('actionAddListCtrl', ['$scope', '$rootScope', '$timeout', 'canvasService', 'helpers', actionAddListCtrl]);

    function actionAddListCtrl($scope, $rootScope, $timeout, canvasService, helpers){
        $scope.displayAddListActionOptions = false;
        $scope.displayError = false;
        $scope.descriptionEmpty = false;
        $scope.createListName = {};
        $scope.search = {};

        $scope.contactOptions = [
            {
                value: 'all-in-any-future',
                message: $scope.translate('commons.all.subscribers')
            },
            {
                value: 'add-contacts-list',
                message: $scope.translate('commons.existing.subscribers')
            },
            {
                value: 'add-contacts-future',
                message: $scope.translate('commons.new.subscribers')
            }
        ];

        function resetNode () {
            $scope.search.list = '';
            $scope.displayAddListActionOptions = false;
            $scope.showSelectListError = false;
        }

        $rootScope.$on('displayActionAddListModal', function(evt, conn, showTip) {
            $scope.contactListData = $rootScope.contactListData;
            $scope.displayAddListActionOptions = true;
            $scope.connections = angular.copy(conn);
            $scope.displayError = false;
            $scope.descriptionEmpty = false;
            $scope.selectedKey = $scope.translate('commons.selectList');

            $timeout(function() {
                $scope.setScrollLogic($scope.connections.id);
            }, 300);

            $scope.sortDataList();
        });

        $scope.sortDataList = () => {
            $scope.contactListData = $scope.contactListData.map((i) => {
                if($scope.connections.data.selectedList.indexOf(i.ListId) > -1) {
                    i.selectedItem = true;
                } else {
                    delete i.selectedItem;
                }

                return i;
            });

            Object.assign($scope.contactListData,  _.orderBy($scope.contactListData, ['selectedItem'],['asc']));
        };

        $rootScope.$on('hideActionAddListModal', function() {
            $scope.displayError = false;
            resetNode();
        });

        $rootScope.$on('displayActionAddListModalError', function() {
            $scope.displayError = true;
        });

        $scope.createListClick = () => {
            $scope.createList = true;
            $scope.displayAddListActionOptions = false;
            $scope.createListName.name = '';
        };

        $scope.goCreateList = () => {
            if (!$scope.createListName.name) {
                $scope.showNewListNameError = true
            }

            if($scope.createListName.name) {
                $scope.createListLoader = true;
                canvasService.createContactList($scope.createListName.name)
                    .success(({Results}) => {
                        $scope.createListLoader = false;
                        if(Results.length) {
                            const result = Results[0];
                            const listItem = {
                                ContactCount: 0,
                                ListId: result.ListId,
                                ListName: result.ListName
                            };
                            $scope.contactListData.unshift(listItem);
                            $rootScope.contactListData.unshift(listItem);
                            $scope.toggelListItem(result.ListId, 0);
                            $scope.goBackList();
                            $rootScope.$emit('errorMsg', $scope.translate('common.list.message'), 'confirmation');
                        }
                        else {
                            $rootScope.$emit('errorMsg', $scope.translate('canvas.error.607'));
                        }
                    })
                    .error(() => {
                        $rootScope.$emit('errorMsg', $scope.translate('canvas.error.607'));
                        $scope.createListLoader = false;
                    });
            }
        };

        $scope.goBackList = () => {
            $scope.createList = false;
            $scope.displayAddListActionOptions = true;
        };

        $scope.cancel = function() {
            resetNode();

            var node = _.find($rootScope.connections, function (conn) {
                return conn.id === $scope.connections.id;
            });

            if (!node) {
                // Execute listener when user cancel the add the node of delay
                $rootScope.$broadcast('deleteAddListNode' + $scope.connections.id);
            }
        };

        $scope.save = function() {
            if ($scope.connections.data.selectedList.length === 0) {
                $scope.showSelectListError = true;
            } else {
                Intercom('trackEvent', 'AP - AddtoList');
                $rootScope.$emit('saveActionAddListData' + $scope.connections.id, $scope.connections, $scope.descriptionEmpty, $scope.contactListData);
            }
        };

        //Toggle List Item to check if a checkbox is checked, If not we add it to the array of IDs, if not we delete it and just save the ones selected
        $scope.toggelListItem = function (listItem, $i) {
            if($scope.connections.isDummy) {
                $scope.connections.data.selectedList = [];
                delete $scope.connections.isDummy;
            }

            var index = $scope.connections.data.selectedList.indexOf(listItem);
            if (index > -1) {
                $scope.connections.data.selectedList.splice(index, 1);
                delete $scope.contactListData[$i].selectedItem;
            } else {
                $scope.connections.data.selectedList.push(listItem);
                $scope.contactListData[$i].selectedItem = true;
            }

            Object.assign($scope.contactListData,  _.orderBy($scope.contactListData, ['selectedItem'],['asc']));

            if ($scope.connections.data.selectedList.length) {
                $scope.selectedKey = $scope.translate('commons.editSelection');
            } else {
                $scope.selectedKey = $scope.translate('commons.selectList');
            }
        };

        $scope.setScrollLogic = function(id) {
            $scope.listLoader = false;
            angular.element(
                document.getElementById('contactListContainer' + id)).bind("scroll",
                function () {
                    if(!$scope.listLoader && !$rootScope.stopLoadingList && !$scope.search.list) {
                        $scope.listLoader = true;
                        canvasService.getContactList($rootScope.contactListOffset, 10)
                            .success(function(data) {
                                if(!data.Results.length) {
                                    $rootScope.stopLoadingList = true;
                                }
                                else {
                                    $rootScope.contactListOffset++;
                                    $rootScope.contactListData = _.uniqBy($rootScope.contactListData.concat(data.Results), 'ListId');
                                    $scope.contactListData = $rootScope.contactListData;
                                    Object.assign($scope.contactListData,  _.orderBy($scope.contactListData, ['selectedItem'],['asc']));
                                }
                                $scope.listLoader = false;
                            })
                            .error(function() {
                                $scope.listLoader = false;
                            })
                    }
                }
            );
        };

        $scope.searching = false;
        $scope.search.search =  (val) => {
            if(val && val.length > 0 && !$scope.searching) {
                $scope.searching = true;
                canvasService.searchContactList(val)
                    .then((res) => {
                        $scope.searching = false;
                        $rootScope.contactListData = _.uniqBy($rootScope.contactListData.concat(res.data.Results), 'ListId');
                        $scope.contactListData = [];
                        $scope.contactListData = $scope.contactListData.concat(res.data.Results);
                        $scope.sortDataList();
                    })
                    .catch(() => {
                        $scope.searching = false;
                    });
            } else {
                $scope.contactListData = $rootScope.contactListData;
                $scope.sortDataList();
            }
        };
    };
})();



// WEBPACK FOOTER //
// ./app/controllers/modals/actionAddListController.js